import React, { useState, useEffect, useRef } from 'react';
import { initializeApp } from 'firebase/app';
import { getFirestore, collection, query, getDocs, limit } from 'firebase/firestore';
import Slider from 'react-slick';
import ModalVideo from 'react-modal-video';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'react-modal-video/css/modal-video.min.css';

const firebaseConfig = {
    apiKey: "AIzaSyCFYUSih8WQVQMS3NfFyO86I0xNe6jxavA",
    authDomain: "cinesageupdated.firebaseapp.com",
    databaseURL: "https://cinesageupdated-default-rtdb.firebaseio.com",
    projectId: "cinesageupdated",
    storageBucket: "cinesageupdated.appspot.com",
    messagingSenderId: "495019934904",
    appId: "1:495019934904:web:e2077b0ef1d7890d40204d"
};

const app = initializeApp(firebaseConfig);
const db = getFirestore(app);

const WatchlistAndAnimation = ({ theme }) => {
    const [movies, setMovies] = useState([]);
    const [searchTerm, setSearchTerm] = useState('');
    const [isOpen, setIsOpen] = useState(false);
    const [currentVideoId, setCurrentVideoId] = useState('');
    const [focusedVideoId, setFocusedVideoId] = useState('');
    const [loading, setLoading] = useState(true);
    const videoRef = useRef(null);

    useEffect(() => {
        const fetchMoviesFromFirestore = async () => {
            try {
                const collections = ['Watchlist', 'Animation', 'Telefilm', 'Documentry', 'Hollywood'];
                const moviePromises = collections.map(collectionName =>
                    getDocs(query(collection(db, collectionName), limit(20)))
                );
                const snapshots = await Promise.all(moviePromises);
                const moviesData = [];
                const seenMovieIds = new Set();

                snapshots.forEach((snapshot, index) => {
                    const category = collections[index];
                    snapshot.docs.forEach(doc => {
                        const movieId = doc.data().ID;
                        if (!seenMovieIds.has(movieId)) {
                            seenMovieIds.add(movieId);
                            moviesData.push({
                                videoId: doc.data().ID,
                                title: doc.data().Title,
                                description: doc.data().Description,
                                url: doc.data().URL,
                                category: category
                            });
                        }
                    });
                });

                setMovies(moviesData);
                setLoading(false);
            } catch (error) {
                console.error('Error fetching movie details:', error);
                setLoading(false);
            }
        };
        fetchMoviesFromFirestore();
    }, []);

    const handleSearchChange = (e) => {
        setSearchTerm(e.target.value);
    };

    const openModal = async (videoId) => {
        setIsOpen(false);
        setCurrentVideoId('');
        setCurrentVideoId(videoId);
        setIsOpen(true);
        setFocusedVideoId(videoId);
        await new Promise(resolve => setTimeout(resolve, 300)); // Wait for modal to open
        requestFullScreen(videoRef.current);
    };

    const closeModal = () => {
        setIsOpen(false);
        setFocusedVideoId('');
    };

    const requestFullScreen = (element) => {
        if (!element) return; // Null check
    };

    const filteredMovies = (category) => {
        const seenTitles = new Set();

        return movies.filter(movie =>
            movie.category === category &&
            movie.title &&
            movie.title.toLowerCase().includes(searchTerm.toLowerCase()) &&
            !seenTitles.has(movie.title) && seenTitles.add(movie.title)
        );
    };

    const truncateDescription = (description, maxLength) => {
        if (!description) return '';
        if (description.length <= maxLength) return description;
        return description.slice(0, maxLength) + '...';
    };

    const sliderSettings = {
        dots: false,
        infinite: false,
        speed: 500,
        slidesToShow: 3, // Changed to 3 slides per view
        slidesToScroll: 3, // Changed to scroll 3 slides
        responsive: [
            {
                breakpoint: 1200,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 2,
                },
            },
            {
                breakpoint: 992,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 2,
                },
            },
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                },
            },
        ],
    };

    if (loading) {
        return <div className="container">Loading...</div>;
    }

    return (
        <div className={`container ${theme}`} style={{ padding: '20px', color: theme === 'dark' ? '#000' : 'white' }}>
            <ModalVideo
                channel="youtube"
                isOpen={isOpen}
                videoId={currentVideoId}
                onClose={closeModal}
            />

            <div className={`container ${theme === 'dark' ? 'light-mode' : 'dark-mode'}`}>
                <h1 className="my-4">Movie List</h1>
                <div className="d-flex justify-content-between mb-4">
                    <input
                        type="text"
                        placeholder="Search by movie title"
                        value={searchTerm}
                        onChange={handleSearchChange}
                        className="form-control"
                        style={{ color: theme === 'light' ? 'black' : 'black' }}
                    />
                </div>
                {['Watchlist', 'Animation', 'Telefilm', 'Documentry', 'Hollywood'].map((category) => (
                    <div key={category} className="category-container" style={{ marginBottom: '40px' }}>
                        <h2 className="category-title" style={{ fontSize: '1.5rem', marginBottom: '20px' }}>{category}</h2>
                        <Slider {...sliderSettings}>
                            {filteredMovies(category).map((movie, index) => (
                                <div
                                    key={movie.videoId}
                                    className={`movie--card ${focusedVideoId && focusedVideoId !== movie.videoId ? 'blurred' : ''}`}
                                    style={{
                                        borderRadius: '8px', // Rounded corners
                                        overflow: 'hidden',
                                        boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
                                        transition: 'transform 0.3s, box-shadow 0.3s ease-in-out',
                                        cursor: 'pointer',
                                        backgroundColor: '#fff', // White background
                                        color: '#333', // Dark text color
                                        margin: '20px', // Adjusted margin
                                        width: '300px',
                                        height: '450px',
                                        display: 'flex',
                                        flexDirection: 'column',
                                        justifyContent: 'space-between', // Add space between elements
                                        border: '1px solid #ddd', // Add border
                                        padding: '10px', // Add padding
                                        marginRight: '20px' // Adjusted margin
                                    }}
                                    onClick={() => openModal(movie.videoId)}
                                >
                                    <div>
                                        <iframe
                                            // ref={videoRef}
                                            style={{
                                                border: 'none',
                                                width: '100%',
                                                height: '200px', // Adjusted height
                                                marginRight: "20px"
                                            }}
                                            src={`https://www.youtube.com/embed/${movie.videoId}`}
                                            title={`Trailer for ${movie.title}`}
                                            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                                            allowFullScreen
                                        ></iframe>
                                        <div style={{ padding: '10px' }}>
                                            <h3 style={{ marginBottom: '10px', fontWeight: 'bold', fontSize: '1.2rem' }}>
                                                {movie.title}
                                            </h3>
                                            <p style={{ marginBottom: '10px', fontSize: '1rem' }}>
                                                {truncateDescription(movie.description, 100)}
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </Slider>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default WatchlistAndAnimation;
